import { api } from '@/api';
import { DRAFT_SEARCH_TEXT_TAG } from '../constants';

export interface SaveDraftRequest {
  draftVersionId: string;
  content: string;
  citationIndexMap: Record<string, number>;
}

export type SaveDraftResponse = Record<string, never>;

const saveDraftApi = api.injectEndpoints({
  endpoints: (builder) => ({
    saveDraft: builder.mutation<SaveDraftResponse, SaveDraftRequest>({
      query: (body) => ({
        url: '/chat/draft/save',
        method: 'POST',
        body,
      }),
      invalidatesTags: [DRAFT_SEARCH_TEXT_TAG],
    }),
  }),
});

export const { useSaveDraftMutation } = saveDraftApi;
